import React from 'react'
import { MDXProvider } from '@mdx-js/react'
import GlobalStyles from './GlobalStyles';

import { ThemeProvider } from '../theme/themeContext';
import mdxComponents from './mdx';


function App({ children }) {
    return (
        <ThemeProvider>
            <GlobalStyles />
            <MDXProvider components={mdxComponents}>
                {children}
            </MDXProvider>
        </ThemeProvider>
    )
}

export default App;
